module.exports = __webpack_public_path__ + "media/images/face-fit-e5d4334d5f0c899cfbf459a082f7b153.jpg";